var init = require("init");

init.then(function (init) {
    require("../sass/normalize.scss");
    require("../sass/mdc-customizations.scss");

    // Import individual components here
    require("@material/layout-grid/mdc-layout-grid.scss");
    require("@material/dialog/mdc-dialog.scss");
    require("@material/card/mdc-card.scss");
    require("@material/elevation/mdc-elevation.scss");

    require("@os/typography/typography.scss");
    require("@os/mdc/button.scss");
    require("@os/mdc/layout-grid.scss");
    require("@os/helper/helper.scss");
    require("../sass/certificate-header/certificate-header.scss");
    require("../sass/certificate-error/certificate-error.scss");
    require("../sass/contact-bottom-block/contact-bottom-block.scss");
    require("../sass/social-media-icon-bar/social-media-icon-bar.scss");

    var templateCertificateError = require("../view/certificate-error.hbs");

    define(["jquery", "i18next", "@os/header", "@os/footer", "@os/hubspot-form"], function (
        $,
        i18next,
        header,
        footer,
        hubspotForm,
    ) {
        $(function () {
            $("#page-content").append(templateCertificateError());
            header.init();
            hubspotForm.init();
        });
    });
});
